import sapdmetroService from '../services/sapdmetro.service';

const sapdmetros = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE

        //READ
        getlist() {
            return sapdmetroService.getlist();
        },

        //UPDATE

        //DELETE
    },
    getters: {},
    mutations: {},
};

export default sapdmetros;
